<template>
  <div>
    <div class="dj-supplier-page erp-list-page baidao-list-page">
      <a-card class="search-card" :bordered="false">
        <div class="supplier-filter-grid">
          <label class="supplier-filter-field">
            <span>供应商名称</span>
            <a-input v-model="query.supplierName" allow-clear placeholder="请输入名称" @pressEnter="handleQuery" />
          </label>
          <label class="supplier-filter-field">
            <span>供应商档案</span>
            <a-input v-model="query.supplierCode" allow-clear placeholder="请输入编码" @pressEnter="handleQuery" />
          </label>
          <label class="supplier-filter-field">
            <span>联系人</span>
            <a-input v-model="query.contactName" allow-clear placeholder="请输入联系人" @pressEnter="handleQuery" />
          </label>
          <label class="supplier-filter-field">
            <span>电话</span>
            <a-input v-model="query.phone" allow-clear placeholder="请输入电话" @pressEnter="handleQuery" />
          </label>
          <label class="supplier-filter-field">
            <span>状态</span>
            <a-select v-model="query.status" allow-clear placeholder="全部">
              <a-select-option v-for="item in enableOptions" :key="item" :value="item">{{ item }}</a-select-option>
            </a-select>
          </label>
          <div class="supplier-filter-actions">
            <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
            <a-button @click="resetQuery"><a-icon type="redo" />重置</a-button>
          </div>
        </div>
      </a-card>

      <a-card class="table-card" :bordered="false">
        <div class="list-toolbar">
          <div class="toolbar-left">
            <a-button v-hasPermi="['erp:supplier:edit']" type="primary" @click="openCreate">+ 新建供应商档案</a-button>
            <a-button @click="exportList">导出</a-button>
            <a-button v-hasPermi="['erp:supplier:edit']" :disabled="!selectedRowKeys.length" @click="confirmSetEnabled(true)">启用</a-button>
            <a-button v-hasPermi="['erp:supplier:edit']" :disabled="!selectedRowKeys.length" @click="confirmSetEnabled(false)">禁用</a-button>
          </div>
        </div>
        <div class="table-wrap">
          <a-table
            class="supplier-list-table"
            row-key="id"
            :columns="columns"
            :data-source="filteredList"
            :loading="loading"
            :pagination="pagination"
            :row-selection="rowSelection"
            :scroll="{ x: 2200 }"
            size="middle">
            <template slot="index" slot-scope="text, record, index">{{ rowIndex(index) }}</template>
            <template slot="code" slot-scope="text, record">
              <a @click="openView(record)">{{ text }}</a>
            </template>
            <template slot="createTime" slot-scope="text">{{ formatCreateTime(text) }}</template>
            <template slot="status" slot-scope="text">
              <span v-if="text" :class="['status-tag', text === '启用' ? 'on' : 'off']">{{ text }}</span>
              <span v-else>—</span>
            </template>
            <template slot="action" slot-scope="text, record">
              <span class="table-links">
                <a-button type="link" size="small" @click="openView(record)">查看</a-button>
                <a-button v-hasPermi="['erp:supplier:edit']" type="link" size="small" @click="openEdit(record)">编辑</a-button>
                <a-button v-hasPermi="['erp:supplier:edit']" type="link" size="small" class="danger-link" @click="confirmDelete(record)">删除</a-button>
              </span>
            </template>
          </a-table>
        </div>
      </a-card>
    </div>

    <a-drawer
      placement="right"
      :width="1180"
      :visible="formVisible"
      :mask-closable="true"
      :wrap-class-name="readOnly ? 'supplier-form-drawer form-readonly' : 'supplier-form-drawer'"
      @close="closeForm">
      <template slot="title">
        <div class="supplier-drawer-title">{{ pageTitle }}</div>
        <div class="supplier-drawer-sub">采购管理 / 供应商档案</div>
      </template>
      <div class="supplier-drawer-shell">
        <div class="supplier-section-tabs">
          <button
            v-for="item in formSections"
            :key="item.key"
            type="button"
            :class="{ active: formTab === item.key }"
            @click="scrollToSection(item.key)">{{ item.title }}</button>
        </div>
        <div ref="drawerScroll" class="supplier-drawer-scroll">
          <section class="dj-form-group" data-section="base">
            <div class="dj-form-group-title">基础信息</div>
            <div class="dj-form-group-grid">
              <div class="field">
                <label>供应商编码</label>
                <a-input :value="draft.supplierCode" disabled placeholder="系统自动生成" />
              </div>
              <div class="field">
                <label>供应商简称</label>
                <a-input v-model="draft.shortName" :disabled="readOnly" placeholder="请输入" />
              </div>
              <div class="field">
                <label class="required">供应商名称</label>
                <a-input v-model="draft.supplierName" :disabled="readOnly" placeholder="请输入" />
              </div>
              <div class="field">
                <label>公司性质</label>
                <a-input v-model="draft.companyNature" :disabled="readOnly" placeholder="请输入" />
              </div>
              <div class="field">
                <label>等级</label>
                <a-select v-model="draft.grade" allow-clear :disabled="readOnly" placeholder="请选择">
                  <a-select-option v-for="item in gradeOptions" :key="item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </div>
              <div class="field">
                <label>备注</label>
                <a-input v-model="draft.remark" :disabled="readOnly" placeholder="请输入" />
              </div>
              <div class="field">
                <label>启用状态</label>
                <a-select
                  :value="draft.enabled === false ? '禁用' : '启用'"
                  :disabled="readOnly"
                  placeholder="请选择"
                  @change="setDraftEnabled">
                  <a-select-option v-for="item in enableOptions" :key="item" :value="item">{{ item }}</a-select-option>
                </a-select>
                <div v-if="!readOnly" class="field-help">保存可改状态；若已被引用需禁用，请回到列表勾选后点「禁用」（会校验引用）。</div>
              </div>
            </div>
          </section>

          <section class="dj-form-group" data-section="contact">
            <div class="dj-form-group-title">联系人与归属</div>
            <div class="dj-form-group-grid">
              <div class="field"><label>联系人</label><a-input v-model="draft.contactName" :disabled="readOnly" placeholder="请输入" /></div>
              <div class="field"><label>手机号</label><a-input v-model="draft.phone" :disabled="readOnly" placeholder="请输入" /></div>
            </div>
          </section>

          <section class="dj-form-group" data-section="settle">
            <div class="dj-form-group-title">结算与合作</div>
            <div class="dj-form-group-grid">
              <div class="field">
                <label>结算方式</label>
                <a-select v-model="draft.settlementMethod" allow-clear :disabled="readOnly" placeholder="请选择">
                  <a-select-option v-for="item in settlementOptions" :key="item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </div>
              <div class="field">
                <label>账期</label>
                <a-select v-model="draft.accountPeriod" allow-clear :disabled="readOnly" placeholder="请选择">
                  <a-select-option v-for="item in periodOptions" :key="item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </div>
              <div class="field"><label>信用期限</label><a-input v-model="draft.creditTerm" :disabled="readOnly" placeholder="请输入" /></div>
            </div>
          </section>

          <section class="dj-form-group" data-section="qual">
            <div class="dj-form-group-title">资质与备注</div>
            <div class="dj-form-group-grid">
              <div class="field"><label>营业执照</label><a-input v-model="draft.licenseNo" :disabled="readOnly" placeholder="请输入" /></div>
              <div class="field"><label>食品经营许可证</label><a-input v-model="draft.foodLicense" :disabled="readOnly" placeholder="请输入" /></div>
              <div class="field"><label>资质附件</label><a-input v-model="draft.qualification" :disabled="readOnly" placeholder="请输入" /></div>
            </div>
          </section>

          <section class="dj-form-group" data-section="warehouse">
            <div class="subtable-head">
              <div class="dj-form-group-title">供应仓库</div>
              <a-button v-if="!readOnly" size="small" icon="plus" @click="addWarehouseBinding">添加仓库</a-button>
            </div>
            <a-table :columns="warehouseColumns" :data-source="draft.warehouseBindings" :pagination="false" :scroll="{ x: 1100 }" row-key="key" size="middle">
              <template slot="index" slot-scope="text, record, index">{{ index + 1 }}</template>
              <template slot="warehouse" slot-scope="text, record">
                <a-select v-model="record.warehouseName" allow-clear show-search option-filter-prop="children" :disabled="readOnly" placeholder="请选择仓库列表数据" style="width:100%">
                  <a-select-option v-for="item in warehouseOptions" :key="item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </template>
              <template slot="purchaseOwner" slot-scope="text, record">
                <a-select v-model="record.purchaseOwner" allow-clear show-search option-filter-prop="children" :disabled="readOnly" placeholder="选择组织架构人员" style="width:100%">
                  <a-select-option v-for="item in staffOptions" :key="'owner-' + item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </template>
              <template slot="purchaseClerk" slot-scope="text, record">
                <a-select v-model="record.purchaseClerk" allow-clear show-search option-filter-prop="children" :disabled="readOnly" placeholder="选择组织架构人员" style="width:100%">
                  <a-select-option v-for="item in staffOptions" :key="'clerk-' + item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </template>
              <template slot="pickerName" slot-scope="text, record">
                <a-select v-model="record.pickerName" allow-clear show-search option-filter-prop="children" :disabled="readOnly" placeholder="选择组织架构人员" style="width:100%">
                  <a-select-option v-for="item in staffOptions" :key="'picker-' + item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </template>
              <template slot="warehouseOwner" slot-scope="text, record">
                <a-select v-model="record.warehouseOwner" allow-clear show-search option-filter-prop="children" :disabled="readOnly" placeholder="选择组织架构人员" style="width:100%">
                  <a-select-option v-for="item in staffOptions" :key="'wh-' + item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </template>
              <template slot="warehouseAction" slot-scope="text, record, index">
                <a-button type="link" size="small" :disabled="readOnly || draft.warehouseBindings.length <= 1" @click="removeWarehouseBinding(index)">删除</a-button>
              </template>
            </a-table>
          </section>

          <section class="dj-form-group" data-section="account">
            <div class="subtable-head">
              <div class="dj-form-group-title">供应商付款账号</div>
              <a-button v-if="!readOnly" size="small" icon="plus" @click="addAccount">添加付款账号</a-button>
            </div>
            <a-table :columns="accountColumns" :data-source="draft.paymentAccounts" :pagination="false" row-key="key" size="middle">
              <template slot="index" slot-scope="text, record, index">{{ index + 1 }}</template>
              <template slot="accountName" slot-scope="text, record">
                <a-input v-model="record.accountName" :disabled="readOnly" placeholder="请输入" />
              </template>
              <template slot="bankName" slot-scope="text, record">
                <a-input v-model="record.bankName" :disabled="readOnly" placeholder="请输入" />
              </template>
              <template slot="accountNo" slot-scope="text, record">
                <a-input v-model="record.accountNo" :disabled="readOnly" placeholder="请输入" />
              </template>
              <template slot="defaultAccount" slot-scope="text, record">
                <a-radio :checked="record.defaultAccount" :disabled="readOnly" @change="markDefault(record)">默认</a-radio>
              </template>
              <template slot="accountAction" slot-scope="text, record, index">
                <a-button type="link" size="small" :disabled="readOnly || draft.paymentAccounts.length <= 1" @click="removeAccount(index)">删除</a-button>
              </template>
            </a-table>
          </section>
        </div>
        <div class="supplier-drawer-footer">
          <a-button @click="closeForm">取消</a-button>
          <a-button v-if="readOnly" v-hasPermi="['erp:supplier:edit']" type="primary" @click="startEdit">编辑</a-button>
          <a-button v-if="!readOnly" type="primary" :loading="saving" @click="save">确定</a-button>
        </div>
      </div>
    </a-drawer>

  </div>
</template>

<script>
import { deleteSupplier, listSupplier, saveSupplier, setSupplierEnabled } from '@/api/erp/supplier'
import { listWarehouse } from '@/api/erp/warehouse'
import { listUser } from '@/api/system/user'

const ARCHIVE_STATUS_OPTIONS = ['草稿', '待审核', '已审核', '执行中', '已完成', '已关闭', '已作废']
const ENABLE_OPTIONS = ['启用', '禁用']
const FALLBACK_WAREHOUSES = ['南京冷链仓', '南京常温仓', '郑州一仓', '上海一仓']

function newKey () {
  return 'k' + Date.now() + Math.random().toString(16).slice(2)
}

function blankAccount (isDefault) {
  return { key: newKey(), accountName: '', bankName: '', accountNo: '', defaultAccount: !!isDefault }
}

function blankMoq () {
  return { key: newKey(), warehouseName: undefined, moqType: '金额', moqValue: 0 }
}

function blankBinding () {
  return {
    key: newKey(),
    warehouseName: undefined,
    purchaseOwner: undefined,
    purchaseClerk: undefined,
    pickerName: undefined,
    warehouseOwner: undefined
  }
}

function joinNames (rows, key, fallback) {
  const values = (rows || []).map(item => item[key]).filter(Boolean)
  const unique = values.filter((item, index) => values.indexOf(item) === index)
  return unique.length ? unique.join('、') : (fallback || '')
}

function blankQuery () {
  return {
    supplierName: '',
    supplierCode: '',
    contactName: '',
    phone: '',
    status: undefined
  }
}

function blankDraft () {
  return {
    id: undefined,
    operatingSubjectId: 0,
    supplierCode: 'GYS-' + String(Date.now()).slice(-6),
    supplierName: '',
    shortName: '',
    companyNature: '',
    grade: undefined,
    status: '草稿',
    enabled: true,
    operatingSubjects: [],
    contactName: '',
    phone: '',
    address: '',
    openDate: undefined,
    purchaseOwner: '',
    purchaseClerk: '',
    pickerName: '',
    settlementMethod: undefined,
    accountPeriod: undefined,
    creditTerm: '',
    portalAccount: '',
    licenseNo: '',
    foodLicense: '',
    bankInfo: '',
    qualification: '',
    remark: '',
    paymentAccounts: [blankAccount(true)],
    warehouseBindings: [blankBinding()],
    warehouseMoqs: [blankMoq()]
  }
}

export default {
  name: 'ErpSupplier',
  data () {
    return {
      loading: false,
      saving: false,
      selectedRowKeys: [],
      formVisible: false,
      readOnly: false,
      formTab: 'base',
      formSections: [
        { key: 'base', title: '基础信息' },
        { key: 'contact', title: '联系人与归属' },
        { key: 'settle', title: '结算与合作' },
        { key: 'qual', title: '资质与备注' },
        { key: 'warehouse', title: '供应仓库' },
        { key: 'account', title: '供应商付款账号' }
      ],
      list: [],
      warehouseOptions: FALLBACK_WAREHOUSES.slice(),
      staffOptions: [],
      enableOptions: ENABLE_OPTIONS,
      archiveStatusOptions: ARCHIVE_STATUS_OPTIONS,
      gradeOptions: ['A', 'B', 'C'],
      settlementOptions: ['账期', '现结', '批结'],
      periodOptions: ['现结', '账期', '预付款', '月清', '批结'],
      query: blankQuery(),
      applied: blankQuery(),
      draft: blankDraft(),
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: total => `共 ${total} 条`,
        onChange: page => { this.pagination.current = page }
      },
      columns: [
        { title: '序号', key: 'index', width: 70, scopedSlots: { customRender: 'index' } },
        { title: '供应商档案', dataIndex: 'supplierCode', width: 140, scopedSlots: { customRender: 'code' } },
        { title: '供应商简称', dataIndex: 'shortName', width: 140 },
        { title: '供应商名称', dataIndex: 'supplierName', width: 200 },
        { title: '公司性质', dataIndex: 'companyNature', width: 120 },
        { title: '等级', dataIndex: 'grade', width: 80 },
        { title: '采购负责人', dataIndex: 'purchaseOwner', width: 120 },
        { title: '采购文员', dataIndex: 'purchaseClerk', width: 110 },
        { title: '提货员', dataIndex: 'pickerName', width: 110 },
        { title: '开户日期', dataIndex: 'openDate', width: 120 },
        { title: '地址', dataIndex: 'address', width: 180 },
        { title: '电话', dataIndex: 'phone', width: 130 },
        { title: '联系人', dataIndex: 'contactName', width: 110 },
        { title: '结算方式', dataIndex: 'settlementMethod', width: 110 },
        { title: '账期', dataIndex: 'accountPeriod', width: 100 },
        { title: '状态', dataIndex: 'enabledLabel', width: 90, scopedSlots: { customRender: 'status' } },
        { title: '创建时间', dataIndex: 'createTime', width: 170, scopedSlots: { customRender: 'createTime' } },
        { title: '操作', key: 'action', width: 180, fixed: 'right', scopedSlots: { customRender: 'action' } }
      ],
      accountColumns: [
        { title: '序号', key: 'index', width: 70, scopedSlots: { customRender: 'index' } },
        { title: '账户名称', key: 'accountName', scopedSlots: { customRender: 'accountName' } },
        { title: '开户银行', key: 'bankName', scopedSlots: { customRender: 'bankName' } },
        { title: '银行账号', key: 'accountNo', scopedSlots: { customRender: 'accountNo' } },
        { title: '是否默认', key: 'defaultAccount', width: 110, scopedSlots: { customRender: 'defaultAccount' } },
        { title: '操作项', key: 'accountAction', width: 80, scopedSlots: { customRender: 'accountAction' } }
      ],
      warehouseColumns: [
        { title: '序号', key: 'index', width: 70, scopedSlots: { customRender: 'index' } },
        { title: '绑定仓库名称', key: 'warehouse', width: 180, scopedSlots: { customRender: 'warehouse' } },
        { title: '采购负责人', key: 'purchaseOwner', width: 150, scopedSlots: { customRender: 'purchaseOwner' } },
        { title: '采购文员', key: 'purchaseClerk', width: 150, scopedSlots: { customRender: 'purchaseClerk' } },
        { title: '提货员', key: 'pickerName', width: 140, scopedSlots: { customRender: 'pickerName' } },
        { title: '仓库负责人', key: 'warehouseOwner', width: 150, scopedSlots: { customRender: 'warehouseOwner' } },
        { title: '操作项', key: 'warehouseAction', width: 80, scopedSlots: { customRender: 'warehouseAction' } }
      ],
      moqColumns: [
        { title: '收货仓库', key: 'warehouse', width: 180, scopedSlots: { customRender: 'warehouse' } },
        { title: 'MOQ类型', key: 'moqType', width: 140, scopedSlots: { customRender: 'moqType' } },
        { title: 'MOQ值', key: 'moqValue', width: 160, scopedSlots: { customRender: 'moqValue' } },
        { title: '操作', key: 'moqAction', width: 80, scopedSlots: { customRender: 'moqAction' } }
      ]
    }
  },
  computed: {
    filteredList () {
      const query = this.applied
      return this.list
        .filter(row => this.matchesQuery(row, query))
        .slice()
        .sort((a, b) => {
          const tb = this.createTimeValue(b.createTime)
          const ta = this.createTimeValue(a.createTime)
          if (tb !== ta) return tb - ta
          return Number(b.id || 0) - Number(a.id || 0)
        })
    },
    pageTitle () {
      if (this.readOnly) return '供应商档案详情'
      return this.draft.id ? '编辑供应商档案' : '新建供应商档案'
    },
    rowSelection () {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: keys => { this.selectedRowKeys = keys }
      }
    }
  },
  created () {
    this.loadList()
    this.loadWarehouses()
    this.loadStaff()
  },
  activated () {
    this.loadWarehouses()
    this.loadStaff()
  },
  methods: {
    rowIndex (index) {
      const page = this.pagination.current || 1
      const size = this.pagination.pageSize || 10
      return (page - 1) * size + index + 1
    },
    handleQuery () {
      this.pagination.current = 1
      this.applied = { ...this.query }
    },
    resetQuery () {
      this.pagination.current = 1
      this.query = blankQuery()
      this.applied = blankQuery()
    },
    matchesQuery (row, query) {
      if (query.status && row.enabledLabel !== query.status) return false
      return this.contains(row.supplierName, query.supplierName)
        && this.contains(row.supplierCode, query.supplierCode)
        && this.contains(row.contactName, query.contactName)
        && this.contains(row.phone, query.phone)
    },
    contains (value, keyword) {
      const text = (keyword || '').trim()
      if (!text) return true
      return String(value || '').indexOf(text) >= 0
    },
    createTimeValue (value) {
      if (value == null || value === '') return 0
      if (Array.isArray(value)) {
        const parts = value.slice()
        while (parts.length < 6) parts.push(0)
        return new Date(parts[0], (parts[1] || 1) - 1, parts[2] || 1, parts[3] || 0, parts[4] || 0, parts[5] || 0).getTime() || 0
      }
      const text = String(value).replace('T', ' ').replace(/-/g, '/')
      const time = new Date(text).getTime()
      return Number.isNaN(time) ? 0 : time
    },
    formatCreateTime (value) {
      if (value == null || value === '') return '—'
      if (Array.isArray(value)) {
        const y = value[0]
        const m = String(value[1] || 1).padStart(2, '0')
        const d = String(value[2] || 1).padStart(2, '0')
        const hh = String(value[3] || 0).padStart(2, '0')
        const mm = String(value[4] || 0).padStart(2, '0')
        const ss = String(value[5] || 0).padStart(2, '0')
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
      }
      return String(value).replace('T', ' ').slice(0, 19)
    },
    exportList () {
      this.$message.info('导出尚未接入')
    },
    isEnabled (record) {
      if (!record) return true
      if (typeof record.enabled === 'boolean') return record.enabled
      return record.status !== 'disabled'
    },
    confirmSetEnabled (enabled) {
      const ids = this.selectedRowKeys.slice()
      if (!ids.length) {
        this.$message.warning('请先勾选供应商')
        return
      }
      const targets = this.list.filter(row => ids.some(id => String(id) === String(row.id)) && this.isEnabled(row) !== enabled)
      if (!targets.length) {
        this.$message.info(enabled ? '所选供应商已是启用状态' : '所选供应商已是禁用状态')
        return
      }
      const action = enabled ? '启用' : '禁用'
      this.$confirm({
        title: '确认' + action + '所选供应商？',
        content: enabled
          ? '启用后可以被商品档案引用。'
          : '禁用后不能再被新业务引用。已被商品或业务单据引用的供应商不能禁用。',
        onOk: () => targets.reduce((chain, row) => chain.then(() => setSupplierEnabled(row.id, enabled)), Promise.resolve()).then(() => {
          this.$message.success(action + '成功')
          this.selectedRowKeys = []
          this.loadList()
        })
      })
    },
    confirmDelete (record) {
      this.$confirm({
        title: '删除供应商档案？',
        content: '已被商品或业务单据引用的供应商不能删除。',
        okType: 'danger',
        onOk: () => deleteSupplier(record.id).then(() => {
          this.$message.success('已删除')
          this.selectedRowKeys = this.selectedRowKeys.filter(id => String(id) !== String(record.id))
          this.loadList()
        })
      })
    },
    loadList () {
      this.loading = true
      listSupplier(false).then(res => {
        const rows = (res && res.data) || []
        this.list = rows.map(row => this.decorate(row))
      }).finally(() => { this.loading = false })
    },
    loadWarehouses () {
      listWarehouse(true).then(res => {
        const names = ((res && res.data) || []).map(item => item.warehouseName).filter(Boolean)
        this.warehouseOptions = names.length ? names : FALLBACK_WAREHOUSES.slice()
      }).catch(() => {
        this.warehouseOptions = FALLBACK_WAREHOUSES.slice()
      })
    },
    loadStaff () {
      listUser({}).then(res => {
        const users = Array.isArray(res && res.data) ? res.data : (((res && res.data) || {}).records || [])
        const names = users.map(user => user.nickName || user.userName).filter(Boolean)
        if (names.length) this.staffOptions = names.filter((item, index) => names.indexOf(item) === index)
      }).catch(() => {})
    },
    parseProfile (raw) {
      if (!raw) return {}
      try {
        const data = typeof raw === 'string' ? JSON.parse(raw) : raw
        return data && typeof data === 'object' ? data : {}
      } catch (e) {
        return {}
      }
    },
    decorate (row) {
      const profile = this.parseProfile(row.profileJson)
      const bindings = Array.isArray(profile.warehouseBindings) ? profile.warehouseBindings : []
      return {
        ...row,
        shortName: profile.shortName || '',
        companyNature: profile.companyNature || '',
        grade: profile.grade || '',
        purchaseOwner: joinNames(bindings, 'purchaseOwner', profile.purchaseOwner),
        purchaseClerk: joinNames(bindings, 'purchaseClerk', profile.purchaseClerk),
        contactName: profile.contactName || '',
        operatingSubjects: Array.isArray(profile.operatingSubjects) ? profile.operatingSubjects : [],
        subjectText: (Array.isArray(profile.operatingSubjects) ? profile.operatingSubjects : []).join('、'),
        settlementMethod: profile.settlementMethod || '',
        accountPeriod: profile.accountPeriod || '',
        phone: profile.phone || '',
        address: profile.address || '',
        openDate: profile.openDate || '',
        creditTerm: profile.creditTerm || '',
        pickerName: joinNames(bindings, 'pickerName', profile.pickerName),
        portalAccount: profile.portalAccount || '',
        statusLabel: profile.archiveStatus || '生效',
        enabled: row.status !== 'disabled',
        enabledLabel: row.status === 'disabled' ? '禁用' : '启用',
        profile
      }
    },
    fillDraft (record) {
      const profile = record.profile || this.parseProfile(record.profileJson)
      const accounts = Array.isArray(profile.paymentAccounts) && profile.paymentAccounts.length
        ? profile.paymentAccounts.map(item => ({ ...blankAccount(false), ...item, key: newKey() }))
        : [blankAccount(true)]
      if (!accounts.some(item => item.defaultAccount)) accounts[0].defaultAccount = true
      const moqs = Array.isArray(profile.warehouseMoqs) && profile.warehouseMoqs.length
        ? profile.warehouseMoqs.map(item => ({ ...blankMoq(), ...item, key: newKey() }))
        : [blankMoq()]
      const savedBindings = Array.isArray(profile.warehouseBindings) ? profile.warehouseBindings : []
      const bindings = savedBindings.length
        ? savedBindings.map(item => ({ ...blankBinding(), ...item, key: newKey() }))
        : [{
          ...blankBinding(),
          purchaseOwner: profile.purchaseOwner || undefined,
          purchaseClerk: profile.purchaseClerk || undefined,
          pickerName: profile.pickerName || undefined
        }]
      this.draft = {
        ...blankDraft(),
        id: record.id,
        operatingSubjectId: record.operatingSubjectId || 0,
        supplierCode: record.supplierCode,
        supplierName: record.supplierName || '',
        shortName: profile.shortName || '',
        companyNature: profile.companyNature || '',
        grade: profile.grade || undefined,
        status: profile.archiveStatus || '草稿',
        enabled: record.status !== 'disabled',
        operatingSubjects: Array.isArray(profile.operatingSubjects) ? profile.operatingSubjects.slice() : [],
        contactName: profile.contactName || '',
        phone: profile.phone || '',
        address: profile.address || '',
        openDate: profile.openDate || undefined,
        purchaseOwner: profile.purchaseOwner || '',
        purchaseClerk: profile.purchaseClerk || '',
        pickerName: profile.pickerName || '',
        settlementMethod: profile.settlementMethod || undefined,
        accountPeriod: profile.accountPeriod || undefined,
        creditTerm: profile.creditTerm || '',
        portalAccount: profile.portalAccount || '',
        licenseNo: profile.licenseNo || '',
        foodLicense: profile.foodLicense || '',
        bankInfo: profile.bankInfo || '',
        qualification: profile.qualification || '',
        remark: record.remark || profile.remark || '',
        paymentAccounts: accounts,
        warehouseBindings: bindings,
        warehouseMoqs: moqs
      }
    },
    openCreate () {
      this.draft = blankDraft()
      this.readOnly = false
      this.formTab = 'base'
      this.formVisible = true
    },
    openView (record) {
      this.fillDraft(record)
      this.readOnly = true
      this.formTab = 'base'
      this.formVisible = true
    },
    openEdit (record) {
      this.fillDraft(record)
      this.readOnly = false
      this.formTab = 'base'
      this.formVisible = true
    },
    startEdit () {
      this.readOnly = false
    },
    closeForm () {
      this.formVisible = false
    },
    scrollToSection (key) {
      this.formTab = key
      const root = this.$refs.drawerScroll
      const el = root && root.querySelector('[data-section="' + key + '"]')
      if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    setDraftEnabled (label) {
      this.draft.enabled = label !== '禁用'
    },
    addAccount () {
      this.draft.paymentAccounts.push(blankAccount(false))
    },
    removeAccount (index) {
      this.draft.paymentAccounts.splice(index, 1)
      if (!this.draft.paymentAccounts.some(item => item.defaultAccount)) {
        this.draft.paymentAccounts[0].defaultAccount = true
      }
    },
    markDefault (record) {
      this.draft.paymentAccounts.forEach(item => { item.defaultAccount = item === record })
    },
    addWarehouseBinding () {
      this.draft.warehouseBindings.push(blankBinding())
    },
    removeWarehouseBinding (index) {
      this.draft.warehouseBindings.splice(index, 1)
    },
    addMoq () {
      this.draft.warehouseMoqs.push(blankMoq())
    },
    removeMoq (index) {
      this.draft.warehouseMoqs.splice(index, 1)
    },
    syncMoq (record) {
      if (record.moqValue == null) record.moqValue = 0
    },
    moqDescription (record) {
      return record.moqType === '数量'
        ? '单张采购订单采购商品总数量需达到该数量'
        : '单张采购订单含税总金额需达到该金额'
    },
    validate () {
      const draft = this.draft
      const missing = []
      if (!draft.supplierName) missing.push('供应商名称')
      if (missing.length) {
        this.$message.warning('请填写' + missing.join('、'))
        return false
      }
      const accounts = draft.paymentAccounts
      if (!accounts.length || !accounts.some(item => item.defaultAccount)) {
        this.$message.warning('请至少保留一个默认付款账号')
        return false
      }
      if (accounts.filter(item => item.defaultAccount).length !== 1) {
        this.$message.warning('只能设置一个默认付款账号')
        return false
      }
      return true
    },
    save () {
      if (!this.validate()) return
      const draft = this.draft
      const profile = {
        shortName: draft.shortName,
        companyNature: draft.companyNature,
        grade: draft.grade,
        contactName: draft.contactName,
        phone: draft.phone,
        address: draft.address,
        openDate: draft.openDate || '',
        settlementMethod: draft.settlementMethod || '',
        accountPeriod: draft.accountPeriod,
        creditTerm: draft.creditTerm,
        portalAccount: draft.portalAccount,
        operatingSubjects: draft.operatingSubjects,
        licenseNo: draft.licenseNo,
        foodLicense: draft.foodLicense,
        bankInfo: draft.bankInfo,
        qualification: draft.qualification,
        archiveStatus: draft.status || '草稿',
        paymentAccounts: draft.paymentAccounts.map(item => ({
          accountName: item.accountName,
          bankName: item.bankName,
          accountNo: item.accountNo,
          defaultAccount: !!item.defaultAccount
        })),
        purchaseOwner: joinNames(draft.warehouseBindings, 'purchaseOwner', ''),
        purchaseClerk: joinNames(draft.warehouseBindings, 'purchaseClerk', ''),
        pickerName: joinNames(draft.warehouseBindings, 'pickerName', ''),
        warehouseBindings: draft.warehouseBindings.map(item => ({
          warehouseName: item.warehouseName || '',
          purchaseOwner: item.purchaseOwner || '',
          purchaseClerk: item.purchaseClerk || '',
          pickerName: item.pickerName || '',
          warehouseOwner: item.warehouseOwner || ''
        })),
        warehouseMoqs: draft.warehouseMoqs.map(item => ({
          warehouseName: item.warehouseName || '',
          moqType: item.moqType,
          moqValue: item.moqValue == null ? 0 : item.moqValue,
          description: this.moqDescription(item)
        }))
      }
      this.saving = true
      saveSupplier({
        id: draft.id ? String(draft.id) : undefined,
        supplierCode: draft.supplierCode,
        supplierName: draft.supplierName,
        operatingSubjectId: draft.operatingSubjectId || 0,
        remark: draft.remark || '',
        status: draft.enabled === false ? 'disabled' : 'enabled',
        profileJson: JSON.stringify(profile)
      }).then(() => {
        this.$message.success('已保存')
        this.formVisible = false
        this.loadList()
      }).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.supplier-filter-grid{display:flex;flex-wrap:wrap;gap:10px 12px;align-items:flex-end}
.supplier-filter-field{display:flex;flex-direction:column;gap:4px;width:200px;min-width:0}
.supplier-filter-field > span{font-size:12px;color:#667085}
.supplier-filter-field /deep/ .ant-select{width:100%}
.supplier-filter-actions{display:flex;align-items:center;gap:8px}
.supplier-filter-actions /deep/ .ant-btn,
.toolbar-left /deep/ .ant-btn{height:32px;padding:0 12px;border-radius:4px;font-size:13px}
.list-toolbar{display:flex;align-items:center;padding-bottom:10px}
.toolbar-left{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.status-tag{display:inline-flex;padding:2px 8px;border-radius:999px;font-size:12px}
.status-tag.on{background:#eafaf0;color:#159447}
.status-tag.off{background:#f0f2f5;color:#778398}
.table-links{display:flex;align-items:center;white-space:nowrap}
.table-links /deep/ .danger-link{color:#f5222d}
</style>

<style>
.supplier-form-drawer .ant-drawer-content-wrapper{max-width:96vw}
.supplier-form-drawer .ant-drawer-wrapper-body{display:flex;flex-direction:column;height:100%;overflow:hidden}
.supplier-form-drawer .ant-drawer-header{flex:0 0 auto;padding:12px 16px}
.supplier-form-drawer .ant-drawer-title{font-weight:400}
.supplier-form-drawer .ant-drawer-body{flex:1;min-height:0;padding:0;overflow:hidden}
.supplier-drawer-shell{display:flex;flex-direction:column;height:100%;min-height:0;background:#fff}
.supplier-drawer-title{font-size:14px;font-weight:600;line-height:1.4;color:#1f2329}
.supplier-drawer-sub{margin-top:2px;font-size:12px;font-weight:400;color:#98a2b3}
.supplier-section-tabs{display:flex;flex-wrap:wrap;gap:6px;padding:10px 16px;border-bottom:1px solid #edf0f4;background:#fff}
.supplier-section-tabs button{height:32px;padding:0 12px;border:1px solid #d8e0ea;border-radius:6px;background:#fff;color:#405068;cursor:pointer}
.supplier-section-tabs button.active{color:#1677ff;border-color:#91caff;background:#e6f4ff}
.supplier-drawer-scroll{flex:1;overflow:auto;padding:12px 16px 16px;background:#f7f8fa}
.supplier-form-drawer .dj-form-group{margin:0 0 10px;padding:12px;background:#fafafa;border:1px solid #e8edf5;border-radius:6px}
.supplier-form-drawer .dj-form-group-title{margin:0 0 10px;padding-left:8px;border-left:3px solid #1677ff;font-size:13px;font-weight:600;line-height:1.2;color:#1f2329}
.supplier-form-drawer .dj-form-group-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px 16px}
.supplier-form-drawer .field-wide{grid-column:1 / -1}
.supplier-form-drawer .field > label{display:block;margin-bottom:4px;color:#344054;font-size:12px}
.supplier-form-drawer .field > label.required::before{content:'*';margin-right:4px;color:#f04438}
.supplier-form-drawer .field-help{margin-top:4px;color:#98a2b3;font-size:12px;line-height:1.5}
.supplier-form-drawer .ant-select{width:100%}
.supplier-form-drawer .portal-entry{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:10px 12px;border:1px solid #e5e9f0;border-radius:6px;background:#fff}
.supplier-form-drawer .portal-entry b{color:#25324b}
.supplier-form-drawer .subtable-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0 0 10px;color:#667085}
.supplier-form-drawer .subtable-head .dj-form-group-title{margin:0}
.supplier-form-drawer .moq-value{display:flex;align-items:center;gap:6px}
.supplier-form-drawer .moq-value .ant-input-number{flex:1}
.supplier-form-drawer .remark-field{margin-top:12px}
.supplier-drawer-footer{display:flex;justify-content:flex-end;gap:8px;padding:10px 16px;border-top:1px solid #e8edf5;background:#fafafa}
.supplier-form-drawer.form-readonly .ant-input[disabled],
.supplier-form-drawer.form-readonly .ant-select-disabled .ant-select-selection,
.supplier-form-drawer.form-readonly .ant-input-number-disabled{color:#667085;background:#f5f6f8}
</style>
